module.exports = __webpack_public_path__ + "static/media/residential-building-large.fa9089e6.webp";